<template>
    <div class="content">
        <div class="content-select">
            <el-row :gutter="20">
                <el-col :span="4">
                    <div class="select-title">
                        <div class="title-img">
                            <img src="@/assets/appraisal/select-icon.png" alt="">
                        </div>
                        <div class="title-info">
                            <span>统计分析</span>
                        </div>
                    </div>
                </el-col>
                <el-col :span="9" :offset="11">
                    <div class="select-serch">
                       <div class="serch-hint"><span>时间范围:</span></div>
                       <div class="serch-info">
                            <div 
                                class="info-item" 
                                v-for="select in selectOption" 
                                :key="select.value"
                                :class="{ active: activeIndex == select.value }"
                                @click="handleSelect(select.value)"
                            >
                                <span>{{ select.label }}</span>
                            </div>
                       </div>
                    </div>
                </el-col>
            </el-row>
        </div>
       <div class="content-header">
            <statiscsHeader  ref="statiscsHeader"  />
       </div>
       <div class="content-info">
          <statiscsInfo  ref="statiscInfo" />
       </div>
    </div>
</template>

<script>
import statiscsHeader from './components/statisicsHeader/index.vue'
import statiscsInfo from './components/statisicsInfo/index.vue'
import '@/assets/css/base.css'
import scaleMixin from '@/utils/scaleMixin.js'
export default {
    name: 'AppraisalStatistics',
    mixins: [scaleMixin],
    components: {
        statiscsHeader,
        statiscsInfo,
    },
    data() {
        return {
            activeIndex: "2", 
            selectOption: [
                {
                    label: '今天',
                    value: '1'
                },
                {
                    label: '最近1周',
                    value: '2'
                },
                {
                    label: '最近1个月',
                    value: '3'
                },
                {
                    label: '最近1年',
                    value: '6'
                }
            ]
        }
    },
    mounted() {
        this.handleSelect(this.activeIndex);

    },
    methods: {
        handleSelect(index) {
            this.activeIndex = index;
            this.$refs.statiscsHeader.getselectHeaderInfo({dateType: this.activeIndex});
            this.$refs.statiscInfo.getSigin({dateType: this.activeIndex});
            this.$refs.statiscInfo.getArtificial({dateType: this.activeIndex});
            this.$refs.statiscInfo.getAppointment({dateType: this.activeIndex});
            this.$refs.statiscInfo.getIntervention({dateType: this.activeIndex});
        },
        
    }
}
</script>

<style lang="scss" scoped>
.content {
    background: #fff;
    display: flex;
    flex-direction: column;

    &-select{
        height: 50px;
        .select-title{
            height: 46px;
            background: url('~@/assets/appraisal/selectBg.png') no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            gap: 12px;
            padding-left: 16px;
            .title-img{
                width: 18px;
                height: 18px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .title-info{
                color: var(--vt-c-black-mute-soft);
                font-size: 16px;
                font-weight: 700;
            }
        }
        .select-serch{
            margin-top: 12px;
            display: flex;
            align-items: center;
            gap: 8px;
            .serch-hint{
                color: var(--vt-c-black-mute-soft);
                font-size: 14px;
                font-weight: 400;
            }
            .serch-info{
                height: 28px;
                display: flex;
                align-items: center;
                gap: 12px;
                .info-item{
                    width: 120px;
                    height: 28px;
                    text-align: center;
                    line-height: 28px;
                    background: var(--vt-c-blue-mute);
                    color: var(--vt-c-blue);
                    border-radius: 2px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    
                    &:hover {
                        opacity: 0.8;
                    }
                    
                    &.active {
                        background: var(--vt-c-blue);
                        color: var(--vt-c-white);
                    }
                    
                    &:active:not(.active) {
                        transform: scale(0.98);
                    }
                }
            }
        }
    }
    &-header{
        margin-top: 16px;
        height: 144px;
        padding: 0 24px;
    }
    &-info{
        margin-top: 16px;
        flex: 1;
        width: 100%;
        padding: 0 24px;
        padding-bottom: 24px;
    }
}
</style>